var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.7 81.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.6,25.1l8.6-3.8c.8-.3,1.2-1.3.8-2.1L25,1c-.3-.8-1.3-1.2-2.1-.8l-8.6,3.8c-.8.3-1.2,1.3-.8,2.1l8,18.2c.4.8,1.3,1.2,2.1.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.5,57.7c-3.4-1.4-7.4-6.1-10.1-11.3-2.1-5.5-2.9-11.7-1.7-15.1,1.1-3.1,2.9-5.1,4.1-6.3h0c-3-6.5-5.9-13.1-8.9-19.6C5.7,7.2,2.4,9.7,1.5,11.9c-3.2,7.9-1.1,24.1,5,39.1h.2c7,14.6,17.7,26.9,25.8,29.9,2.2.8,6.2,0,11.1-2.7-2.9-6.6-5.8-13.1-8.6-19.7h0c-1.8.3-4.5.3-7.5-1v.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.2,77.9l8.6-3.8c.8-.3,1.2-1.3.8-2.1l-8-18.2c-.3-.8-1.3-1.2-2.1-.8l-8.6,3.8c-.8.3-1.2,1.3-.8,2.1l8,18.2c.4.8,1.3,1,2.1.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.ef37c4b75ec1750d9d6b9735ccae6e24.svg";
export { ForwardRef as ReactComponent };